import BasicContentVideoWithBanner from './BasicContentVideoWithBanner';

export { type BasicContentVideoWithBannerProps } from './BasicContentVideoWithBanner';
export default BasicContentVideoWithBanner;
